import { render, staticRenderFns } from "./Village.vue?vue&type=template&id=410cd62a&scoped=true&"
import script from "./Village.vue?vue&type=script&lang=js&"
export * from "./Village.vue?vue&type=script&lang=js&"
import style0 from "./Village.vue?vue&type=style&index=0&id=410cd62a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410cd62a",
  null
  
)

export default component.exports